import { useEffect, useState } from "react";
import translation from "./translation.json";
import MobileDetect from "mobile-detect";
import { parse } from "query-string";

import {
  gaInitial,
  gaSetPageView,
  initialDataLayer,
  setPageType,
} from "../../utils/gtm";

const useRobinsonHome = () => {
  const languages = {
    th: "th_TH",
    en: "en_US",
  };

  const [isMobile, setIsMobile] = useState();
  const [currentLang, setCurrentLang] = useState();
  const [currentLangCode, setCurrentLangCode] = useState();
  const [shouldAnimate, setShouldAnimate] = useState(false);
  const [isRedirected, setIsRedirected] = useState(false);

  const appDeepLink = process.env.REACT_APP_DEEP_LINK;

  const handleRedirect = (toWeb = false) => {
    if (!isRedirected) {
      setIsRedirected(true);
      if (toWeb) {
        const baseUrl = process.env.REACT_APP_BASE_URL;
        const centralBaseUrl = baseUrl?.replace("robinson", "central");
        const lowerCaseLangCode = currentLang?.toLowerCase();
        const robinsonShopInShopPath = `${centralBaseUrl}/${lowerCaseLangCode}/shop/robinson`;
        setTimeout(
          () => window.location.assign(robinsonShopInShopPath),
          isMobile ? 1000 : 0
        );
      } else {
        window.location.assign(appDeepLink);
      }
    }
  };

  const handleLanguageAnimation = () => {
    if (!shouldAnimate) {
      setShouldAnimate(true);
      setTimeout(() => {
        setShouldAnimate(false);
      }, 10);
    }
  };

  const handleSwitchLanguage = (langCode) => {
    const lowerCaseLangCode = langCode?.toLowerCase();
    if (currentLang !== langCode && lowerCaseLangCode in languages) {
      // window.history.replaceState(null, null, `/${langCode}`);
      setCurrentLang(langCode);
      setCurrentLangCode(languages[lowerCaseLangCode]);
      handleLanguageAnimation();
    }
  };

  const translate = (key) => {
    return translation?.[`${currentLangCode}`]?.[`${key}`] || "";
  };

  useEffect(() => {
    const md = new MobileDetect(window.navigator.userAgent);
    setIsMobile(md.mobile() !== null);

    // const firstFourCharOfPath = window.location.pathname.substring(0, 4);
    // if (
    //   firstFourCharOfPath !== "/en" &&
    //   firstFourCharOfPath !== "/en/" &&
    //   firstFourCharOfPath !== "/th" &&
    //   firstFourCharOfPath !== "/th/"
    // ) {
    //   handleSwitchLanguage("th");
    // } else {
    //   const desiredLang = firstFourCharOfPath.substring(1, 3);
    //   handleSwitchLanguage(desiredLang);
    // }

    const lang = parse(window.location.search)?.lang?.toLowerCase() || "th";
    if (lang in languages) {
      handleSwitchLanguage(lang);
    } else {
      handleSwitchLanguage("th");
    }

    initialDataLayer();

    const trackingId = process.env.REACT_APP_GOOGLE_TRACKING_ID;
    gaInitial(trackingId);

    const pathname = window?.location?.pathname;
    const search = window?.location?.search;
    gaSetPageView({ pathname, search });
    setPageType({ pageType: "home" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    handleRedirect,
    handleSwitchLanguage,
    translate,
    isMobile,
    langCode: currentLang,
    shouldAnimate,
    isRedirected,
  };
};

export default useRobinsonHome;
